import { render } from "./linkPages.vue?vue&type=template&id=4cab6b37&scoped=true"
import script from "./linkPages.vue?vue&type=script&lang=js"
export * from "./linkPages.vue?vue&type=script&lang=js"

import "./linkPages.vue?vue&type=style&index=0&id=4cab6b37&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cab6b37"]])

export default __exports__